import { useDispatch, useSelector } from "react-redux";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import { selectDeletableField } from "../../../sub-modules/management/store/selectors/salesforce/exportSelectors";
import { selectHsDeletableField } from "../../../sub-modules/management/store/selectors/hubspot/exportSelectors";
import { selectDynamicsDeletableField } from "../../../sub-modules/management/store/selectors/dynamics/exportSelectors";
import { setHsDeletableField } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/hubspot";
import { setSfDeletableField } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/salesforce";
import { setDynamicsDeletableField } from "app/pages/sales-intelligence/sub-modules/management/store/actions/export/dynamics";
import { deleteExportSettingThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/export";
import { deleteSFExportSettingThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/export";
import { deleteDynamicsExportSettingThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/export";
import type { ExportSetting } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import type { UseDeleteModalPropsType } from "./type";

export const useDeleteModalProps = (integrationName: Integration): UseDeleteModalPropsType => {
    const allProps = {
        salesforce: {
            deleteField: selectDeletableField,
            setDelField: setSfDeletableField,
            delSetting: deleteSFExportSettingThunk,
        },
        hubspot: {
            deleteField: selectHsDeletableField,
            setDelField: setHsDeletableField,
            delSetting: deleteExportSettingThunk,
        },
        dynamics: {
            deleteField: selectDynamicsDeletableField,
            setDelField: setDynamicsDeletableField,
            delSetting: deleteDynamicsExportSettingThunk,
        },
    };
    const { deleteField, setDelField, delSetting } = allProps[integrationName];

    const dispatch = useDispatch();

    const deletableField = useSelector(deleteField);
    const setDeletableField = (field: ExportSetting | undefined) => dispatch(setDelField(field));
    const deleteSetting = (setting: ExportSetting) => dispatch(delSetting(setting));

    return { deleteSetting, setDeletableField, deletableField };
};
